function SidebarPanelController() {
    const ctrl = this;
    ctrl.icons = null;
    ctrl.show = ctrl.show || true;
    ctrl.loading = ctrl.loading = true;

    ctrl.$onInit = () => {
        ctrl.selectOne = ctrl.selectOne || false;

        // Validation
        if (Array.isArray(ctrl.items) === false) {
            console.error("SidebarPanel: items is not defined as an array");
            return;
        }
        for (const item of ctrl.items) {
            if (typeof item === 'object' && (ctrl.icons === null || ctrl.icons === true)) {
                ctrl.icons = true;

                if (typeof item.name !== 'string') {
                    console.error(`SidebarPanel: item.name [${item}] is not a string`);
                    return;
                }
                if (typeof item.iconClass !== 'string') {
                    console.error(`SidebarPanel: item.iconClass [${item}] is not a string`);
                    return;
                }
            } else if (typeof item !== 'string' && (ctrl.icons === null || ctrl.icons === false)) {
                ctrl.icons = false;

                console.error(`SidebarPanel: item [${item}] is not a string`);
                return;
            }
        }

        if (Array.isArray(ctrl.selected) === false) {
            console.error("SidebarPanel: selected is not defined as an array");
            return;
        }

        if (typeof ctrl.onSelect !== 'function') {
            console.error("SidebarPanel: on-select is not defined as a function");
            return;
        }
    };

    /**
     * Open / Close
     */
    ctrl.toggleOpen = () => {
        ctrl.show = !ctrl.show;

        if (typeof ctrl.onShowChange === 'function') {
            ctrl.onShowChange(ctrl.show);
        }
    };

    /**
     * Icons
     */
    ctrl.iconsAreUsed = (item) => {
        return typeof item === 'object';
    };

    /**
     * Selection
     */
    ctrl.selectItem = (item) => {
        if (ctrl.loading) {
            return;
        }
        if (ctrl.iconsAreUsed(item)) {
            item = item.name;
        }
        if (ctrl.selectOne) {
            ctrl.selected = [item]
            ctrl.onSelect(ctrl.selected);
            return 
        } 
        const index = _.indexOf(ctrl.selected, item);
 
        if (index >= 0) {
           ctrl.selected.splice(index, 1);
        } else {
            ctrl.selected.push(item);
        }

        ctrl.onSelect(ctrl.selected);
    };
    ctrl.itemIsSelected = (item) => {
        if (ctrl.iconsAreUsed(item)) {
            item = item.name;
        }

        return _.indexOf(ctrl.selected, item) >= 0;
    };
}

angular
    .module('sidebar.module')
    .controller('SidebarPanelController', SidebarPanelController);